jQuery(function ($) {
  // -----------------------------
  // 絞り込み（条件クリア）
  // -----------------------------
  $(document).on("click", ".js-filter-clear", function (e) {
    e.preventDefault();

    const $form = $(this).closest("form");
    if (!$form.length) return;

    $form
      .find(
        'input[type="checkbox"][name="cs_cat[]"], input[type="checkbox"][name="m_cat[]"]',
      )
      .prop("checked", false)
      .trigger("change");

    const $keyword = $form.find('input[type="text"][name="keyword"]');
    if ($keyword.length) {
      $keyword.val("");
      $keyword.prop("disabled", true);
    }

    $form[0].submit();
  });
});
